import { parse, stringify } from 'jsurl2';
import { isEmpty, isObject, isString } from 'lodash-es';
import type { InferType, Schema } from 'yup';
import * as yup from 'yup';

export const getUrlParams = (str: string) => {
  const params = Object.fromEntries(new URLSearchParams(str));

  return params;
};

export const packObjectToURIComponent = (obj: Record<string | number, unknown> | unknown[]) => {
  if (!isObject(obj) || isEmpty(obj)) {
    return null;
  }

  let res = null;

  try {
    res = stringify(obj);
  } catch (error) {
    console.error('Failed to pack obj', obj);
  }

  return res;
};

// The `ordering` URL param: column ids, prefixed with `-` for descending
export const urlOrderingSchema = yup.array(yup.string().defined()).defined();

/**
 * Unpacks a string packed with `packObjectToURIComponent` and validates the result against a yup schema.
 * Returns null when the string can't be unpacked or the unpacked value doesn't match the schema.
 */
export const unpackURIComponentToObject = <TSchema extends Schema>(
  str: string | null,
  schema: TSchema
): InferType<TSchema> | null => {
  if (!isString(str) || str === '' || !str.endsWith('~')) {
    return null;
  }

  let res: unknown = null;

  try {
    res = parse(str);
  } catch (error) {
    console.error('Failed to unpack str', str);
  }

  return schema.isValidSync(res, { strict: true }) ? res : null;
};

export const getUrlBase = () => {
  const protocol = window.location.protocol + '//';
  const split = window.location.host.split(':');
  const newHost = split.length > 1 ? split[0] + ':8000' : split[0];
  return protocol + newHost;
};

export const URL_BASE = getUrlBase();

export const expandParameterMap = (parameterMap: Record<string, unknown>): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(parameterMap).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        // Add each array item as a separate parameter with the same name
        value.forEach((item) => {
          params.append(key, String(item));
        });
      } else {
        params.append(key, String(value));
      }
    }
  });

  return params;
};
